module.exports = __webpack_public_path__ + "files/66e6009664ac00f622975c525801412c.png";